import PagePhase from '@/enum/PagePhase'
import PlayerType from '@/enum/PlayerType'
import AppConfig from '@/app-config'
export default {
	clientId: 'meet-a-side',

	playerType: PlayerType.Teacher,

	backgroundAccent: 'primary',
	
	breadcrumbTo: null,
	gameClientType: null, // GameClientType.Offline,
	gameType: null,

	currentTheme: null,
	currentCase: null,

	session: null, // Used to store student votes for one case
	sessionId: null,

	lastEmojiCode: null,

	currentGamePhase: null,

	currentPageIndex: -1,
	currentPagePhase: PagePhase.Normal,
	pageHistory: [],

	gameClientCloseRedirectUrl: '/',

	errorMessage: null,
	errorIcon: null,
	navigationGuardEnabled: false,

	language: 'en',

	appVersion: process.env.VUE_APP_VERSION,

	showFooter: true,

	autoThemeSelection: null,
	autoCaseSelection: null,
	autoRoomCode: null,

	features: AppConfig.features,

	showHeaderCaseName: true,

	admin: {
		pages: []
	}
}
